import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import moment from 'moment';

const BlogPostSchema = ({
  datePublished,
  title,
  heroImage,
  author,
  content,
  summary
}) => {

  let data = {
    '@context': 'http://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    datePublished: moment(datePublished).format('YYYY-MM-DD'),
    description: summary,
    articleBody: content
  };

  if (author) {
    data = { ...data, author: { '@type': 'Person', name: author } };
  }

  if (heroImage && typeof heroImage === 'string') {
    data = { ...data, image: { '@type': 'ImageObject', url: heroImage } };
  }

  return (
    <Helmet>
      <script type='application/ld+json'>{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default BlogPostSchema

BlogPostSchema.propTypes = {
  title: PropTypes.string.isRequired,
  datePublished: PropTypes.string.isRequired,
  author: PropTypes.string,
  heroImage: PropTypes.string,
  content: PropTypes.string.isRequired,
  summary: PropTypes.string
};

BlogPostSchema.defaultProps = {
  heroImage: null,
  author: null,
  summary: ''
};
